/**
 * Created by lu on 2018/5/11.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view: {
        'class': 'radio-wrap',
        $html: [{
            $type: require('./Radio'),
            $model: ''
        }, {
            'class': 'inner',
            tag: 'label',
            for: nb.bind('inputId'),
            $html: {
                $slot: 'inner'
            }
        },{
            'class':'selected-icon'
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/form/RadioWrap.js
// module id = 53
// module chunks = 0 2 3 8 9 15 22 23